import React from 'react';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon({
  title: 'uitloggen',
  content: /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16, -139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14, 136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "2",
    y: "3",
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,19.9c-1,0.7-2.3,1.2-3.6,1.2C8.7,21.1,6,18.4,6,15s2.7-6.1,6.1-6.1c1.4,0,2.6,0.4,3.6,1.2l1.4-1.4 c-1.4-1.1-3.1-1.8-5-1.8C7.6,6.9,4,10.5,4,15c0,4.5,3.6,8.1,8.1,8.1c1.9,0,3.6-0.7,5-1.8L15.7,19.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.4,16 12.4,14 22.4,14 22.4,16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4,12 19.8,10.6 24.2,15 22.8,16.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4,18 19.8,19.4 24.2,15 22.8,13.6"
  })))
});